import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface AxisChangeEvent {
  axis: string;
  index: number;
  value: number;
}

export interface TickChangeEvent {
  axis: string;
  value: number;
}

@Component({
  selector: 'app-xy-line-plot-axis-editor',
  templateUrl: './xy-line-plot-axis-editor.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class XyLinePlotAxisEditorComponent {
  public readonly plotState = input<any>(null);
  public readonly yMinIndex = input<number>(0);
  public readonly yMaxIndex = input<number>(1);
  public readonly legendBelowPlot = input<boolean>(false);

  public readonly axisChanged = output<AxisChangeEvent>();
  public readonly tickChanged = output<TickChangeEvent>();
  public readonly reset = output<void>();

  public onAxisBlur(ref: any, axis: string, index: number): void {
    if (ref.value == null) {
      return;
    }
    this.axisChanged.emit({ axis, index, value: ref.value });
  }

  public onTickBlur(ref: any, axis: string): void {
    if (ref.value === '') {
      return;
    }
    this.tickChanged.emit({ axis, value: ref.value });
  }
}
